"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _clsx = _interopRequireDefault(require("clsx"));

var _styles = require("@material-ui/core/styles");

var _Dialog = _interopRequireDefault(require("@material-ui/core/Dialog"));

var _DialogTitle = _interopRequireDefault(require("@material-ui/core/DialogTitle"));

var _IconButton = _interopRequireDefault(require("@material-ui/core/IconButton"));

var _Close = _interopRequireDefault(require("@material-ui/icons/Close"));

var _useTranslate = _interopRequireDefault(require("@sprinx/react-globalize/useTranslate"));

var _SelectMultipleFilterMobile = _interopRequireDefault(require("../../../filter/SelectMultipleFilterMobile"));

var _FilterConditionParameter = _interopRequireDefault(require("../../../filter/FilterConditionParameter"));

var _FilterConditionPrice = _interopRequireDefault(require("../../../filter/FilterConditionPrice"));

var _CatalogueProductListMultipleFilterContainer = _interopRequireDefault(require("./CatalogueProductListMultipleFilterContainer"));

var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    root: {
      '& .MuiPaper-root': {
        backgroundColor: theme.palette.common.white
      }
    },
    headerTitle: (0, _extends2.default)({}, theme.typography.body1),
    headerTitleContainer: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      paddingTop: theme.spacing(1),
      paddingBottom: theme.spacing(1),
      paddingLeft: theme.spacing(3),
      paddingRight: theme.spacing(1),
      borderBottom: '1px solid',
      borderBottomColor: theme.palette.divider
    },
    dialogContent: {
      flexGrow: 1,
      display: 'flex',
      paddingTop: theme.spacing(1)
    }
  };
}, {
  name: 'ProductListMultipleFilterMobileDialog'
});

var _ref2 = /*#__PURE__*/_react.default.createElement(_Close.default, null);

function ProductListMultipleFilterMobileDialog(_ref) {
  var buildFilter = _ref.buildFilter,
      pClasses = _ref.classes,
      className = _ref.className,
      currency = _ref.currency,
      filter = _ref.filter,
      filterFields = _ref.filterFields,
      filterHash = _ref.filterHash,
      onChange = _ref.onChange,
      onClose = _ref.onClose,
      open = _ref.open,
      parentFilter = _ref.parentFilter,
      resetFilter = _ref.resetFilter,
      total = _ref.total,
      rest = (0, _objectWithoutProperties2.default)(_ref, ["buildFilter", "classes", "className", "currency", "filter", "filterFields", "filterHash", "onChange", "onClose", "open", "parentFilter", "resetFilter", "total"]);
  var classes = useStyles({
    classes: pClasses
  });
  var t = (0, _useTranslate.default)();
  return /*#__PURE__*/_react.default.createElement(_Dialog.default, (0, _extends2.default)({}, rest, {
    open: open,
    onClose: onClose,
    fullScreen: true,
    className: (0, _clsx.default)(classes.root, className)
  }), /*#__PURE__*/_react.default.createElement(_DialogTitle.default, {
    disableTypography: true,
    className: classes.headerTitleContainer
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: classes.headerTitle
  }, t('productListMultipleFilterMobileDialog/headerTitle')), /*#__PURE__*/_react.default.createElement(_IconButton.default, {
    onClick: onClose
  }, _ref2)), /*#__PURE__*/_react.default.createElement(_CatalogueProductListMultipleFilterContainer.default, {
    className: classes.dialogContent
  }, /*#__PURE__*/_react.default.createElement(_SelectMultipleFilterMobile.default, {
    buildFilter: buildFilter,
    currency: currency,
    filter: filter,
    filterHash: filterHash,
    onChange: onChange,
    onClose: onClose,
    resetFilter: resetFilter,
    parentFilter: parentFilter
  }, /*#__PURE__*/_react.default.createElement(_FilterConditionParameter.default, {
    onChange: onChange,
    key: '_manufacturer',
    field: '_manufacturer',
    parameterName: '_manufacturer',
    buildFilter: buildFilter
  }), filterFields.map(function (f) {
    return /*#__PURE__*/_react.default.createElement(_FilterConditionParameter.default, {
      onChange: onChange,
      key: f,
      field: f,
      parameterName: f,
      buildFilter: buildFilter
    });
  }), /*#__PURE__*/_react.default.createElement(_FilterConditionPrice.default, {
    onChange: onChange,
    buildFilter: buildFilter,
    currency: currency,
    field: "price",
    priceField: "priceWithTax"
  }))));
}

process.env.NODE_ENV !== "production" ? ProductListMultipleFilterMobileDialog.propTypes = {
  buildFilter: _propTypes.default.func,
  classes: _propTypes.default.shape({
    dialogContent: _propTypes.default.string,
    headerTitle: _propTypes.default.string,
    headerTitleContainer: _propTypes.default.string,
    root: _propTypes.default.string
  }),
  className: _propTypes.default.string,
  currency: _propTypes.default.string,
  filter: _propTypes.default.oneOfType([_propTypes.default.shape({}), _propTypes.default.shape(_propTypes.default.arrayOf())]),
  filterFields: _propTypes.default.arrayOf(_propTypes.default.string),
  filterHash: _propTypes.default.string,
  handleChangeOrder: _propTypes.default.func,
  onChange: _propTypes.default.func,
  onChangeRowsPerPage: _propTypes.default.func,
  onClose: _propTypes.default.func,
  open: _propTypes.default.bool,
  parentFilter: _propTypes.default.arrayOf(_propTypes.default.shape()),
  resetFilter: _propTypes.default.func,
  rowsPerPage: _propTypes.default.number,
  total: _propTypes.default.number,
  value: _propTypes.default.shape({})
} : void 0;
ProductListMultipleFilterMobileDialog.defaultProps = {
  buildFilter: undefined,
  classes: undefined,
  className: undefined,
  currency: undefined,
  filter: undefined,
  filterFields: undefined,
  filterHash: undefined,
  handleChangeOrder: undefined,
  onChange: undefined,
  onChangeRowsPerPage: undefined,
  onClose: undefined,
  open: undefined,
  parentFilter: undefined,
  resetFilter: undefined,
  rowsPerPage: undefined,
  total: undefined,
  value: undefined
};
var _default = ProductListMultipleFilterMobileDialog;
exports.default = _default;